import { FC, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "../../../../../../hook/useAppDispatch";
import { useAppSelector } from "../../../../../../hook/useAppSelector";
import { useAutocompleteSearch } from "../../../../../../hook/autocomplete-search/useAutocompleteSearch";
import { useClearAutocompleteSearch } from "../../../../../../hook/autocomplete-search/useClearAutocompleteSearch";

import {
  setSearchInput,
  clearAutocompleteList,
} from "../../../../../../store/slice/health-monitor/device-list";

import { loadDeviceList } from "../../../../../../util/route/loader/load-device-list";

import magnifier from "../../../../../../assets/img/png/health-monitor/magnifier.png";

import AutocompleteDropdown from "./AutocompleteDropdown";


const SearchInput: FC = () => {
  const searchInput = useAppSelector((state) => state.deviceList.searchInput);
  const shouldRefreshDeviceListOnClear = useRef(false);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useAutocompleteSearch();
  useClearAutocompleteSearch();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    dispatch(setSearchInput(e.target.value));

    if (shouldRefreshDeviceListOnClear.current) {
      shouldRefreshDeviceListOnClearHandler(false);
      loadDeviceList();
    }
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      shouldRefreshDeviceListOnClearHandler(true);
      dispatch(clearAutocompleteList());
      loadDeviceList();
    }
  };

  const shouldRefreshDeviceListOnClearHandler = (shouldRefresh: boolean) => {
    shouldRefreshDeviceListOnClear.current = shouldRefresh;
  };

  return (
    <div className="search_box">
      <img src={magnifier} alt="magnifier"></img>
      <input
        type="search"
        spellCheck={false}
        value={searchInput || ""}
        onChange={(e) => handleOnChange(e)}
        onKeyDown={(e) => handleOnKeyDown(e)}
        placeholder={`${t("healthMonitor.header.filter.inputPlaceholder")}`}
      ></input>

      <AutocompleteDropdown
        handleShouldRefreshDeviceListOnClear={
          shouldRefreshDeviceListOnClearHandler
        }
      ></AutocompleteDropdown>
    </div>
  );
};

export default SearchInput;
